import useUserStore from '~/store/modules/user'
import useBasicStore from '~/store/modules/basic'
import CryptoJS from "crypto-js"
// 它非常适合运行不应阻塞应用程序初始渲染的代码
export async function appMountInit() {
    if (!onNuxtReady) return;
    onNuxtReady( async () => {
        const userStore = useUserStore()
        const basicStore = useBasicStore()
        // 如果token存在，则获取用户信息
        // userStore.token && await userStore.getUserInfo()
        await basicStore.getHomePageConfig()
        // userStore.getRoleRights()
        // await basicStore.getLanguages()
        // await userStore.getTranslateEngines()
    })
}

// 需要初始化的服务器数据
export async function appMountInterfaceInit() {
}

export async function getMD5FileString(file: File) {
    console.log("getMD5FileString==", file)
    if (!file) {
        return '';
    }
    return new Promise((resolve, reject)=>{
        let fileReader = new FileReader()
        fileReader.onload = (e) => {
            // 修改成上传统计前100M文本参与md5
            const wordArray = CryptoJS.lib.WordArray.create(e.target?.result?.slice(0, 104857600));
            const md5Hash = CryptoJS.MD5(wordArray).toString(CryptoJS.enc.Hex)
            resolve(md5Hash)
        }
        fileReader.readAsArrayBuffer(file)
    })
}